import { render, staticRenderFns } from "./consumptionRule.vue?vue&type=template&id=bc89d6f0&scoped=true&"
import script from "./consumptionRule.vue?vue&type=script&lang=js&"
export * from "./consumptionRule.vue?vue&type=script&lang=js&"
import style0 from "./consumptionRule.vue?vue&type=style&index=0&id=bc89d6f0&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc89d6f0",
  null
  
)

export default component.exports